import { render, staticRenderFns } from "./MonthlyView.vue?vue&type=template&id=53794452&scoped=true&"
import script from "./MonthlyView.vue?vue&type=script&lang=js&"
export * from "./MonthlyView.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyView.vue?vue&type=style&index=0&id=53794452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53794452",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VList } from 'vuetify/lib/components/VList';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VAvatar,VChip,VList,VMain})
